export const capitalizeText = (text: string): string => {
    return text.toLowerCase().replace(/(^|\s)\w/g, (word) => word.toUpperCase());
};

export const getTruncateDescription = (description: string, maxLength: number) => {
    if (description.length <= maxLength) {
        return description;
    }
    const truncated = description.substring(0, maxLength - 3);
    return truncated + '...';
};

export const slugify = (text: string) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-');
};

export const declineWord = (number: number, word1: string, word2: string, word5: string) => {
    let lastDigit = number % 10;
    if (number % 100 >= 11 && number % 100 <= 19) {
        return word5;
    } else if (lastDigit === 1) {
        return word1;
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return word2;
    } else {
        return word5;
    }
};

export const formatPhoneNumber = (phone: string): string => {
    return phone.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})(.*)/, '+$1 ($2) $3 $4 $5$6');
};

/** Убирает HTML-теги и декодирует базовые сущности — для поиска по видимому тексту */
export const stripHtmlTags = (html: string): string => {
    return html
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/(p|div|li|h[1-6]|tr|blockquote)>/gi, ' ')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim();
};

/** Подсветка совпадений только в текстовых узлах, без затрагивания тегов */
export const highlightInHtml = (html: string, pattern: RegExp): string => {
    const flags = pattern.flags.includes('g') ? pattern.flags : `${pattern.flags}g`;
    const regex = new RegExp(pattern.source, flags);

    return html.replace(/(<[^>]+>)|([^<]+)/g, (part, tag, text) => {
        if (tag) {
            return tag;
        }
        return text.replace(regex, '<mark>$&</mark>');
    });
};

/** Экранирование спецсимволов для RegExp */
export const escapeRegExp = (value: string): string => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/** Экранирование HTML для безопасного вывода текста */
export const escapeHtml = (value: string): string => {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

/** Заголовок задачи: taskName или начало описания */
export const getTaskTitle = (task: { taskName?: string | null; taskContent?: string | null }): string => {
    if (task.taskName && task.taskName.trim()) {
        return task.taskName.trim();
    }
    const fromContent = stripHtmlTags(task.taskContent || '').trim();
    if (!fromContent) {
        return 'Без названия';
    }
    return fromContent.length > 120 ? `${fromContent.slice(0, 120)}…` : fromContent;
};

/** Подсветка в обычном тексте (не HTML) */
export const highlightPlainText = (text: string, pattern: RegExp): string => {
    const flags = pattern.flags.includes('g') ? pattern.flags : `${pattern.flags}g`;
    const regex = new RegExp(pattern.source, flags);
    const parts: string[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = regex.exec(text)) !== null) {
        parts.push(escapeHtml(text.slice(lastIndex, match.index)));
        parts.push(`<mark>${escapeHtml(match[0])}</mark>`);
        lastIndex = match.index + match[0].length;
        if (match[0].length === 0) {
            regex.lastIndex += 1;
        }
    }
    parts.push(escapeHtml(text.slice(lastIndex)));
    return parts.join('');
};
